import store from "utils/store.js";

export default function setNews(news) {
  store.dispatch({
    type: "news/set",
    payload: news,
  });
}
